import { render } from "./PantrySelectDeleteBar.vue?vue&type=template&id=bd4ed404&ts=true"
import script from "./PantrySelectDeleteBar.vue?vue&type=script&lang=ts"
export * from "./PantrySelectDeleteBar.vue?vue&type=script&lang=ts"

import "./PantrySelectDeleteBar.vue?vue&type=style&index=0&id=bd4ed404&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__